export default __webpack_public_path__ + "static/media/uniswap.29c2da39.svg";